/**
 * @description Axios client configured for time clock kiosk API calls
 *
 * Key features:
 * - Base URL from config
 * - Automatic session token injection via interceptor
 * - 401 response handling (redirect to employee select)
 *
 * @dependencies
 * - axios: HTTP client
 * - config: API URL
 */

import axios from 'axios';
import config from './config';

const apiClient = axios.create({
  baseURL: config.apiUrl,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor: attach session token if present
apiClient.interceptors.request.use((reqConfig) => {
  const token = sessionStorage.getItem('clockSessionToken');
  if (token) {
    reqConfig.headers.Authorization = `Bearer ${token}`;
  }
  return reqConfig;
});

// Response interceptor: handle session expiry
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Session expired - clear storage and trigger re-auth
      sessionStorage.removeItem('clockSessionToken');
      sessionStorage.removeItem('clockEmployeeId');
      // Dispatch custom event for ClockContext to handle
      window.dispatchEvent(new CustomEvent('clockSessionExpired'));
    }
    return Promise.reject(error);
  }
);

export default apiClient;
